<template>
  <b-modal id="deleteTokenModal" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop  @hide="resetModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'trash']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <h6 class="element-header mb-0 text-center">{{t('deleteToken', 'deleteToken')}}</h6>
      <p class="text-center">{{t('areYouSureYouWantToDeleteThisToken', 'areYouSureYouWantToDeleteThisToken')}}</p>
      <ResponseInfo class="mt-5" v-if="(getResponseInfo.responseName == 'deleteTokenTranslation') && (getResponseInfo.status == 'error')"></ResponseInfo>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
        </button>
        <template >
          <button class="btn btn-danger" type="button" @click="deleteToken(modal.tokenData.id, modal.tokenData.language, $event.target)">
            <fontAwesomeIcon :icon="['fa', 'trash']" class="text-light mr-2"/> {{ t('deleteTokenTranslationButtonText', 'deleteTokenTranslationButtonText')}}
          </button>
        </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalDeleteToken',
  inject: [
    'resetModal',
    'modal',
    'deleteToken'
  ],
  data () {
    return {
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  created() {
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>
.modal-open #deleteTokenModal___BV_modal_outer_ >>> .modal-content{
  min-width: 750px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #deleteTokenModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}
.modal-open #deleteTokenModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
</style>
